import React from "react";

const Unsupported = () => {
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100vh",
                backgroundColor: "#f8f9fa",
                color: "#343a40",
                textAlign: "center",
                padding: "2rem",
            }}
        >
            <h1 style={{ fontSize: "2rem", marginBottom: "1rem" }}>
                האפליקציה אינה נתמכת במכשירים ניידים
            </h1>
            <p style={{ fontSize: "1.2rem", marginBottom: "2rem" }}>
                אנא השתמש במחשב שולחני כדי לגשת לאפליקציה.
            </p>

            <p style={{ fontSize: "1rem", color: "#6c757d" }}>
                תודה על ההבנה שלך!
            </p>
        </div>
    );
};

export default Unsupported;
